/**
 * [input type] [input type] [input type] [input type] [input type] [input type] [input type]
  {
    (null 가능) inputDateISOString : '2024-08-20T03:36:34.596Z', // 근데 "2024-08-20"같은 입력을 받기도 하고 또한 이래도 에러는 안나서 걍 쓰는중.
    (null 가능) inputYearNum: 2024,
    (null 가능) inputMonthNum: 8,
    (null 가능) inputDayNum: 20,
    outputType: "outputYMD" or "outputYM",
    location: "KR" or "US"... 
  }
*/

/**
 * 국가별 날짜 표현법 참고방법.
 * https://ko.wikipedia.org/wiki/날짜_형식에_따른_나라_목록
 * 혹은 1년지난 (그래야 년도표기하므로) 인스타 페이지 접근후 언어변경하여 파악 가능
 */

/**
 * 국가별 날짜 표현법 참고방법.
 * https://ko.wikipedia.org/wiki/날짜_형식에_따른_나라_목록
 * 혹은 1년지난 (그래야 년도표기하므로) 인스타 페이지 접근후 언어변경하여 파악 가능
 */

const monthIndex = {
  US: {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December"
  },
  GB: {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December"
  },
  CA: {
    1: "January",
    2: "February",
    3: "March",
    4: "April",
    5: "May",
    6: "June",
    7: "July",
    8: "August",
    9: "September",
    10: "October",
    11: "November",
    12: "December"
  },
  FR: {
    1: "janvier",
    2: "février",
    3: "mars",
    4: "avril",
    5: "mai",
    6: "juin",
    7: "juillet",
    8: "août",
    9: "septembre",
    10: "octobre",
    11: "novembre",
    12: "décembre"
  },
  RUOfYMD: {
    1: "января",
    2: "февраля",
    3: "марта",
    4: "апреля",
    5: "мая",
    6: "июня",
    7: "июля",
    8: "августа",
    9: "сентября",
    10: "октября",
    11: "ноября",
    12: "декабря"
  },
  RUOfYM: {
    1: "Январь",
    2: "Февраль",
    3: "Март",
    4: "Апрель",
    5: "Май",
    6: "Июнь",
    7: "Июль",
    8: "Август",
    9: "Сентябрь",
    10: "Октябрь",
    11: "Ноябрь",
    12: "Декабрь"
  },
  DE: {
    1: "Januar",
    2: "Februar",
    3: "März",
    4: "April",
    5: "Mai",
    6: "Juni",
    7: "Juli",
    8: "August",
    9: "September",
    10: "Oktober",
    11: "November",
    12: "Dezember"
  },
  IT: {
    1: "gennaio",
    2: "febbraio",
    3: "marzo",
    4: "aprile",
    5: "maggio",
    6: "giugno",
    7: "luglio",
    8: "agosto",
    9: "settembre",
    10: "ottobre",
    11: "novembre",
    12: "dicembre"
  },
  ES: {
    1: "enero",
    2: "febrero",
    3: "marzo",
    4: "abril",
    5: "mayo",
    6: "junio",
    7: "julio",
    8: "agosto",
    9: "septiembre",
    10: "octubre",
    11: "noviembre",
    12: "diciembre"
  }
};

const isWrongNum = num => {
  return !Number.isInteger(num);
};

const checkInput = inputObj => {
  const {
    inputDateISOString,
    inputYearNum,
    inputMonthNum,
    inputDayNum,
    outputType
  } = inputObj;

  if (!(outputType === "outputYMD" || outputType === "outputYM")) {
    throw Error(`[dateFormatString]wrong outputType : ${outputType}`);
  } else if (
    outputType === "outputYMD" &&
    !inputDateISOString &&
    (isWrongNum(inputYearNum) ||
      isWrongNum(inputMonthNum) ||
      isWrongNum(inputDayNum))
  ) {
    console.error(`[dateFormatString]wrong input`, {
      outputType,
      inputDateISOString,
      inputYearNum,
      inputMonthNum,
      inputDayNum
    });
    throw Error(`[dateFormatString]wrong input`);
  } else if (
    outputType === "outputYM" &&
    !inputDateISOString &&
    (isWrongNum(inputYearNum) || isWrongNum(inputMonthNum))
  ) {
    console.error(`[dateFormatString]wrong input`, {
      outputType,
      inputDateISOString,
      inputYearNum,
      inputMonthNum,
      inputDayNum
    });
    throw Error(`[dateFormatString]wrong input`);
  }
};

const getNumsOfDate = inputObj => {
  const { inputDateISOString, inputYearNum, inputMonthNum, inputDayNum } =
    inputObj;

  const inputType = inputDateISOString ? "fullDateText" : "inputYM";

  switch (inputType) {
    case "fullDateText":
      const dateObj = new Date(inputDateISOString);
      return {
        numYear: dateObj.getFullYear(),
        numMonth: dateObj.getMonth() + 1,
        numDay: dateObj.getDate()
      };
    case "inputYM":
      return {
        numYear: inputYearNum,
        numMonth: inputMonthNum,
        numDay: inputDayNum
      };
    default:
      console.error(`[dateFormatString]wrong inputType`, inputObj);
      throw Error(`[dateFormatString]wrong inputType`);
  }
};

const getCapitalized = input => {
  return input.charAt(0).toUpperCase() + input.slice(1);
};

const getLocale = inputObj => {
  const { location } = inputObj;

  switch (location) {
    case "KR":
      return "ko-KR";
    case "JP":
      return "ja-JP";
    case "CN":
      return "zh-CN";
    case "RU":
      return "ru-RU";
    case "IT":
      return "it-IT";
    case "ES":
      return "es-ES";
    case "DE":
      return "de-DE";
    case "FR":
      return "fr-FR";
    case "GB":
      return "en-GB";
    case "US":
    default:
      return "en-US";
  }
};

const getYearWord = (numYear, location) => {
  switch (location) {
    case "KR":
      return `${numYear}년`;
    case "JP":
    case "CN":
      return `${numYear}年`;
    case "RU":
    case "US":
    case "GB":
    case "CA":
    case "FR":
    case "DE":
    case "IT":
    case "ES":
      return `${numYear}`;

    default:
      console.error(`[dateFormatString]wrong location : ${location}`);
      return `${numYear}`;
  }
};

const getMonthWord = (monthType, numMonth, location) => {
  if (!(monthType === "forYMD" || monthType === "forYM")) {
    console.error(`[DateText]wrong monthType : ${monthType}`);
    return `${numMonth}`;
  }

  switch (location) {
    case "KR":
      return `${numMonth}월`;
    case "JP":
    case "CN":
      return `${numMonth}月`;
    case "RU":
      if (monthType === "forYMD") {
        return monthIndex.RUOfYMD[numMonth];
      } else {
        return monthIndex.RUOfYM[numMonth];
      }
    case "US":
    case "GB":
    case "CA":
    case "FR":
    case "DE":
    case "IT":
    case "ES":
      return monthIndex[location][numMonth];

    default:
      console.error(`[DateText]wrong location : ${location}`);
      return monthIndex["US"][numMonth];
  }
};

const getDateYMD = inputObj => {
  const { displayWeekday } = inputObj;
  const { numYear, numMonth, numDay } = getNumsOfDate(inputObj);

  if (isWrongNum(numYear) || isWrongNum(numMonth) || isWrongNum(numDay)) {
    throw Error(
      `[dateFormatString]wrong number : ${numYear},${numMonth},${numDay}`
    );
  }

  const locale = getLocale(inputObj);

  const resultDate = new Date(numYear, numMonth - 1, numDay);
  /**
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DateTimeFormat/DateTimeFormat#options
   */
  const dateStr = resultDate.toLocaleDateString(locale, {
    dateStyle: "long"
  });
  const weekdayDateStr = resultDate.toLocaleDateString(locale, {
    weekday: "short", // 또는 "long" (예: "Saturday" 대신 "Sat")
    year: "numeric",
    month: "long",
    day: "numeric"
  });
  return displayWeekday ? weekdayDateStr : dateStr;
};

const getDateYM = inputObj => {
  /**
   * const resDateText = resultDate.toLocaleDateString(locale, { year: "numeric", month: "long" });
   * 상단의 코드처럼 표현할 수 있겠으나, RU와 ES에서 조금 다른 결과값을 보여주기에 기존 코드를 그냥 사용하기로 결졍.
   * 잡지의 표지에 사용되는 날짜표현 방식대로의 표현법을 목표로 설정한 상황
   * (RU : [현재]"Март 2022", [toLocaleDateString 방식]"Март 2022 г.")
   * (ES : [현재]"Marzo 2022", [toLocaleDateString 방식]"Marzo de 2022")
   */
  const { location } = inputObj;
  const { numYear, numMonth } = getNumsOfDate(inputObj);

  if (isWrongNum(numYear) || isWrongNum(numMonth)) {
    throw Error(`[dateFormatString]wrong number : ${numYear},${numMonth}`);
  }

  const strYear = getYearWord(numYear, location);
  const strMonth = getMonthWord("forYM", numMonth, location);

  switch (location) {
    case "KR":
      return `${strYear} ${strMonth}`;
    case "JP":
    case "CN":
      return `${strYear}${strMonth}`;
    case "FR":
    case "IT":
    case "ES":
    case "RU":
    case "DE":
    case "US":
    case "GB":
    case "CA":
    default:
      return `${getCapitalized(strMonth)} ${strYear}`;
  }
};

const getDateText = inputObj => {
  const { outputType } = inputObj;

  checkInput(inputObj);

  switch (outputType) {
    case "outputYMD":
      return getDateYMD(inputObj);
    case "outputYM":
      return getDateYM(inputObj);

    default:
      throw Error(`[dateFormatString]wrong outputType : ${outputType}`);
  }
};

export { getDateText };
